import { render } from "./Fehler.vue?vue&type=template&id=4c6f44bb"
import script from "./Fehler.vue?vue&type=script&lang=js"
export * from "./Fehler.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__